
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Header from "../component/include/Header";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from "../constants/Global";
import DataService from "../services/tutorial.service";
import { logUser } from "../actions/index";
import { useSelector, useDispatch } from "react-redux";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'


function Forgot() {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const dispatch = useDispatch();
    const loginuser = useSelector((state) => state.setUserlog);
    const isjoin = useSelector((state) => state.isjoin);
    const [cid, setCid] = useState(loginuser["cid"]);
    const [token, settoken] = useState(loginuser["token"]);
    const [mobvalue, setmobValue] = useState("")

    const [isDisabled, setDisabled] = useState(false);
    const history = useHistory({ forceRefresh: true });
    const [isdone, setisdone] = useState(false)
    const [countrynum, setcountrynum] = useState('+91')


    const onSubmit = (values) => {

        setDisabled(true);
        var mobileformat = formatPhoneNumberIntl(mobvalue)
        let parts = mobileformat.split(' ');

        // Extract country code and phone number
        // let countryCode = parts[0];
        let phoneNumber = mobvalue
        // console.log(countryCode)
        // console.log(phoneNumber)
        if (phoneNumber == "") {
            toast.error("Mobile Number is required !!", {
                theme: "colored",
                position: "bottom-center",
            });
            setDisabled(false);

            return 0
        }
        else if (phoneNumber.length < 8) {
            toast.error("At least 9 digit number !!", {
                theme: "colored",
                position: "bottom-center",
            });
            setDisabled(false);

            return 0
        }
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        const HEADER = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache",
                "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
            },
        };
        values['mob'] = phoneNumber
        values['ccode'] = countrynum



        DataService.forgotpass(values, HEADER)
            .then((res) => {
                let response = res.data;
                // console.log(response)
                toast.dismiss(toastContainerId);

                if (response.success == true) {
                    setisdone(true)
                } else {
                    toast.error(response.msg, {
                        theme: "colored",
                        position: "bottom-center",
                    });
                }

                setDisabled(false);
            })
            .catch(() => {
                // console.log("Not valid");
                toast.dismiss(toastContainerId);
                toast.error("Not valid Server Error", {
                    theme: "colored",
                    position: "bottom-center",
                });
                setDisabled(false);
            });
    };

    useEffect(() => {
        // // loadCaptchaEnginge(6, "white", "black");
        // window.scrollTo(0, 0);
        // console.log(window.__initial_headers__)
        // const queryParameters = new URLSearchParams(window.location.search)
        // // front login from map
        // const aval = queryParameters.get("mob")
        // const bval = queryParameters.get("key")
        // // front login from other
        // // const
        // const uid = queryParameters.get("uid")
        // const mkey = queryParameters.get("mkey")

        // /////////////////////////
        // const aidval = queryParameters.get("aid")
        // const cval = queryParameters.get("acode")
        // const pg = queryParameters.get("p")
        // console.log("parametersssssssssss")
        // if (pg !== null) {
        //     if (pg == 'login') {
        //         history.push(BASE_PATH);

        //     }
        //     else if (pg == 'registration') {
        //         history.push(BASE_PATH + "user-registration");

        //     }
        //     else if (pg == 'dashboard') {
        //         history.push(BASE_PATH + "dashboard");
        //     }
        //     else if (pg == 'profile') {
        //         history.push(BASE_PATH + "my-profile");

        //     }
        //     else if (pg == 'newauction') {
        //         console.log("new auc hitt")
        //         history.push(BASE_PATH + "new-auction");

        //     }
        //     else if (pg == 'joinauction') {
        //         history.push(BASE_PATH + "join-auction");

        //     }
        //     else if (pg == 'myauction') {
        //         history.push(BASE_PATH + "my-auction");

        //     }
        //     else if (pg == 'auctionpanel') {
        //         document.getElementById('acp1').value = cid;
        //         document.getElementById('acp2').value = 0;
        //         document.getElementById('acp3').value = token;
        //         document.getElementById('acpform').submit();

        //     }

        // }
        // if (aval !== null && mkey !== null && uid !== null) {
        //     const HEADER = {
        //         headers: {
        //             "Content-Type": "application/x-www-form-urlencoded",
        //             "Cache-Control": "no-cache",
        //             "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
        //         },
        //     };
        //     console.log(uid)
        //     console.log(aval)
        //     console.log(mkey)
        //     DataService.keyloginUser({ 'cid': uid, 'mobno': aval, 'mkey': mkey }, HEADER)
        //         .then((res) => {
        //             console.log("key login res.data")
        //             console.log(res.data)
        //             let response = res.data;

        //             if (response.success == true) {
        //                 var emptyArray = JSON.stringify(new Array(response.data));
        //                 localStorage.setItem("user", emptyArray);
        //                 dispatch(logUser(response.data));

        //                 toast.success(response.msg, {
        //                     theme: "dark",
        //                     position: "bottom-center",
        //                 });

        //                 history.push(BASE_PATH + "my-auction");
        //             } else {
        //                 toast.error(response.msg, {
        //                     theme: "colored",
        //                     position: "bottom-center",
        //                 });
        //             }

        //         })
        // }
        // if (aval !== null && bval !== null) {
        //     if (aidval !== null) {
        //         localStorage.setItem('auction_id', aidval)
        //         localStorage.setItem('isadel', aidval)
        //     }

        //     const HEADER = {
        //         headers: {
        //             "Content-Type": "application/x-www-form-urlencoded",
        //             "Cache-Control": "no-cache",
        //             "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
        //         },
        //     };
        //     DataService.loginUser({ 'mobno': aval, 'pass': bval }, HEADER)
        //         .then((res) => {
        //             console.log("res.data")
        //             console.log(res.data)
        //             let response = res.data;

        //             if (response.success == true) {
        //                 var emptyArray = JSON.stringify(new Array(response.data));
        //                 localStorage.setItem("user", emptyArray);
        //                 dispatch(logUser(response.data));

        //                 toast.success(response.msg, {
        //                     theme: "dark",
        //                     position: "bottom-center",
        //                 });

        //                 history.push(BASE_PATH + "my-auction");
        //             } else {
        //                 toast.error(response.msg, {
        //                     theme: "colored",
        //                     position: "bottom-center",
        //                 });
        //             }

        //         })


        // }
        // else if (loginuser != "" && pg == null) {
        //     console.log("form here")
        //     history.push(BASE_PATH + "dashboard");
        // }
        // console.log(logUser['cid'])
        // if (cval !== null) {
        //     localStorage.setItem('acode', cval)

        //     if (localStorage.getItem('user')) {
        //         history.push(BASE_PATH + "join-auction-code");

        //     }
        //     else {
        //         console.log("playing safe")
        //         history.push(BASE_PATH + "join-auction-code2");

        //     }


        // }



    }, []);

    const handleCountrychange = () => {
        const phoneInput = document.querySelector('.PhoneInputInput');
        const phoneValue = phoneInput ? phoneInput.value : '';
        setcountrynum(phoneValue); // Logs the value of the input field
      };

    const fmsgus = () => {
        window.open('https://wa.me/918386011123', '_blank');
    }
    return (
        <>
            {/* <Header /> */}
            <div className="login-area default-padding">
                <div className="container">
                    <div className="row">
                        <form id="acpform" method='get' action="https://superplayerauction.com/manage/?frnt=1" target="_blank">
                            <input type="hidden" id="acp1" name="cid" />
                            <input type="hidden" id="acp2" name="aid" />
                            <input type="hidden" id="acp3" name="fkey" />
                            {/* <input type="hidden" name="loginbyadmin" value="1" /> */}

                        </form>
                        <div className="col-md-6 col-md-offset-3">
                            <form
                                onSubmit={handleSubmit(onSubmit)}
                                action=""
                                autoComplete="off"
                                id="login-form"
                                className="white-popup-block regfrm"
                                encType="multipart/form-data"
                            >
                                <div className="col-md-12">
                                    <h4>Forgot Password !! No problem</h4>
                                    <p>It will be send by sms to your mobile number</p>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="form-group mymar phonediv">
                                                {/* <input
                                                    maxLength={10}
                                                    minLength={10}
                                                    className="form-control"
                                                    placeholder="Mobile No"
                                                    type="number"
                                                    onInput={(e) => {
                                                        e.target.value = Math.max(
                                                            0,
                                                            parseInt(e.target.value)
                                                        )
                                                            .toString()
                                                            .slice(0, 10);
                                                    }}
                                                    {...register("mob", {
                                                        required: true,
                                                        maxLength: 10,
                                                        required: "required field.",
                                                        maxLength: {
                                                            value: 10,
                                                            message: "at-least 10 characters.",
                                                        },
                                                        minLength: {
                                                            value: 10,
                                                            message: "at-least 10 characters.",
                                                        },
                                                    })}
                                                />
                                                {errors.mobno && (
                                                    <p className="text-error">{errors.mobno.message}</p>
                                                )} */}
                                                <PhoneInput
                                                    international
                                                    // initialValueFormat="international"
                                                    withCountryCallingCode={false}

                                                    defaultCountry="IN"
                                                    countryCallingCodeEditable={false}
                                                    // value={mobvalue}
                                                    onChange={
                                                        (v) => { handleCountrychange() }}
    
                                                    minLength={9}


                                                />
                                                <span className="text-gray-500">{countrynum}</span>
                                                <input
                                                    onChange={(e) => setmobValue(e.target.value)}
                                                    value={mobvalue}
                                                    type="text"
                                                    placeholder="Enter mobile number"
                                                    className="ml-2"
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col-md-12">
                                        <div className="row">
                                            <div className="form-group mymar">
                                                <input
                                                    {...register("pass", {
                                                        required: true,
                                                        required: "required field.",
                                                    })}
                                                    className="form-control"
                                                    placeholder="Password"
                                                    type="password"
                                                />
                                                {errors.pass && (
                                                    <p className="text-error">{errors.pass.message}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div> */}

                                    {/* <div className="row">
                                        <div
                                            className="col-md-4 captcha"
                                            style={{ textAlign: "center" }}
                                        >
                                            <LoadCanvasTemplate
                                                reloadText="Reload  Captcha"
                                                reloadColor="#002147"
                                                className="cpchafont"

                                            />
                                        </div>

                                        <div className="col-md-8 cpcha">
                                            <div>
                                                <input
                                                    placeholder=" Enter Captcha Value"
                                                    {...register("user_captcha_input", {
                                                        required: true,
                                                        required: "required field.",
                                                    })}
                                                    id="user_captcha_input"
                                                    type="text"
                                                    style={{ width: "100%" }}
                                                ></input>
                                            </div>
                                            {errors.user_captcha_input && (
                                                <p className="text-error">
                                                    {errors.user_captcha_input.message}
                                                </p>
                                            )}
                                        </div>
                                    </div> */}

                                    <div className="col-md-12" style={{ marginTop: 15 }}>
                                        <div className="row">
                                            <div className=" padding-l regsubmbtn">
                                                {!isdone && <button disabled={isDisabled} type="submit">
                                                    Request for password
                                                </button>}{isdone &&
                                                    <>
                                                        <p style={{ width: '100%', backgroundColor: 'green', padding: '.5rem 1rem', color: 'white' }}>Your password has been sent to your mobile number by SMS . <br /><span className="not-rec"> If didn't receive , Message us on whatsApp </span><b className="f-msg-us" onClick={() => fmsgus()}> +91-8386011123</b></p>
                                                        {/* <p style={{backgroundColor:'green',padding:'.5rem 1rem',color:'white'}}></p> */}
                                                        <button onClick={() => { history.push('/') }} disabled={isDisabled} type="submit">
                                                            Login
                                                        </button>
                                                    </>
                                                }
                                            </div>

                                            {/* <div className="col-md-8 padding-r align-right regbdiv">
                                                <p className="link-bottom regb">
                                                    {" "}
                                                    Not a member yett?{" "}
                                                    <Link to="user-registration">Register now</Link>
                                                </p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Forgot;
